<div class="flex justify-end w-full" *ngIf="index == 0">
  <button
    class="bg-indigo-600 hover:bg-indigo-700 rounded-md text-white py-[6px] px-[14px] cursor-pointer shadow-sm transition-all duration-300 font-medium flex items-center gap-2"
    (click)="exitToEntityList()"
  >
    <i class="fas fa-arrow-left text-sm"></i> Back To Entity List
  </button>
</div>

<div class="flex flex-col gap-4 mt-4 max-w-6xl mx-auto" *ngIf="index === 0">
  <div class="flex justify-between items-center">
    <div class="text-lg font-semibold text-indigo-800 flex items-center gap-2">
      <i class="fas fa-shield-alt"></i> Role Permissions
      <span class="text-sm font-normal text-gray-500" *ngIf="selectedRolesForEntity.length > 0">
        ({{ selectedRolesForEntity.length }} {{ selectedRolesForEntity.length === 1 ? 'role' : 'roles' }})
      </span>
    </div>
    <button
      (click)="toggleAddRoleModal()"
      class="bg-indigo-600 hover:bg-indigo-700 rounded-md text-white py-[8px] px-[16px] cursor-pointer shadow-sm transition-all duration-300 flex items-center gap-2"
    >
      <i class="fas fa-plus text-sm"></i> Add Role
    </button>
  </div>
  
  <!-- Empty State -->
  <div *ngIf="selectedRolesForEntity.length === 0" class="bg-white rounded-lg border-2 border-dashed border-gray-300 p-12 text-center">
    <div class="flex flex-col items-center gap-4">
      <div class="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center">
        <i class="fas fa-user-shield text-3xl text-indigo-600"></i>
      </div>
      <div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">No Roles Added Yet</h3>
        <p class="text-gray-600 mb-4">Add roles to configure CRUD permissions for this entity</p>
        <button
          (click)="toggleAddRoleModal()"
          class="bg-indigo-600 hover:bg-indigo-700 rounded-md text-white py-2 px-6 cursor-pointer shadow-sm transition-all duration-300 inline-flex items-center gap-2"
        >
          <i class="fas fa-plus text-sm"></i> Add Your First Role
        </button>
      </div>
    </div>
  </div>

  <!-- Roles Table -->
  <div *ngIf="selectedRolesForEntity.length > 0" class="bg-white rounded-lg overflow-hidden shadow-md border border-indigo-200">
    <table class="w-full border-collapse">
      <thead class="bg-gradient-to-r from-indigo-100 to-indigo-50">
        <tr>
          <th class="px-6 py-4 border-b border-indigo-200 text-left text-indigo-900 font-semibold">
            <div class="flex items-center gap-2">
              <i class="fas fa-user-tag"></i> Role Name
            </div>
          </th>
          <th class="px-4 py-4 border-b border-indigo-200 text-center text-indigo-900 font-semibold w-28">
            <div class="flex flex-col items-center gap-1">
              <i class="fas fa-plus-circle text-green-600"></i>
              <span class="text-xs">Create</span>
            </div>
          </th>
          <th class="px-4 py-4 border-b border-indigo-200 text-center text-indigo-900 font-semibold w-28">
            <div class="flex flex-col items-center gap-1">
              <i class="fas fa-eye text-blue-600"></i>
              <span class="text-xs">Read</span>
            </div>
          </th>
          <th class="px-4 py-4 border-b border-indigo-200 text-center text-indigo-900 font-semibold w-28">
            <div class="flex flex-col items-center gap-1">
              <i class="fas fa-edit text-amber-600"></i>
              <span class="text-xs">Update</span>
            </div>
          </th>
          <!-- Delete is intentionally NOT grantable to end-user roles: nothing is user-deletable in the
               app; record deletes and AAOB child add/update/delete are handled by the system. -->
          <th class="px-4 py-4 border-b border-indigo-200 text-center text-indigo-900 font-semibold w-20">
            <span class="text-xs">Action</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let role of selectedRolesForEntity; let i = index">
          <tr 
            class="transition-all duration-150 border-b border-gray-100"
            [ngClass]="{
              'bg-indigo-50 hover:bg-indigo-100': hasAnyPermission(role.id),
              'hover:bg-gray-50': !hasAnyPermission(role.id)
            }"
          >
            <td class="px-6 py-4 font-medium text-gray-900">
              <div class="flex items-center gap-2">
                <span 
                  class="w-2 h-2 rounded-full"
                  [ngClass]="{
                    'bg-indigo-500': hasAnyPermission(role.id),
                    'bg-gray-300': !hasAnyPermission(role.id)
                  }"
                ></span>
                {{ role.name }}
              </div>
            </td>
            <td class="px-4 py-4 text-center">
              <label class="inline-flex items-center cursor-pointer group">
                <input
                  type="checkbox"
                  [checked]="getRolePermission(role.id, 'create')"
                  (change)="toggleRolePermission(role.id, 'create')"
                  autocomplete="off"
                  class="w-5 h-5 rounded border-2 border-gray-300 text-green-600 focus:ring-2 focus:ring-green-500 focus:ring-offset-1 cursor-pointer transition-all duration-150"
                />
              </label>
            </td>
            <td class="px-4 py-4 text-center">
              <label class="inline-flex items-center cursor-pointer group">
                <input
                  type="checkbox"
                  [checked]="getRolePermission(role.id, 'read')"
                  (change)="toggleRolePermission(role.id, 'read')"
                  autocomplete="off"
                  class="w-5 h-5 rounded border-2 border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 cursor-pointer transition-all duration-150"
                />
              </label>
            </td>
            <td class="px-4 py-4 text-center">
              <label class="inline-flex items-center cursor-pointer group">
                <input
                  type="checkbox"
                  [checked]="getRolePermission(role.id, 'update')"
                  (change)="toggleRolePermission(role.id, 'update')"
                  autocomplete="off"
                  class="w-5 h-5 rounded border-2 border-gray-300 text-amber-600 focus:ring-2 focus:ring-amber-500 focus:ring-offset-1 cursor-pointer transition-all duration-150"
                />
              </label>
            </td>
            <!-- No Delete cell — end-user roles can't be granted delete (handled by the system). -->
            <td class="px-4 py-4 text-center">
              <button
                (click)="removeRoleFromEntity(role.id)"
                class="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50 transition-all duration-150"
                title="Remove role from entity"
              >
                <i class="fas fa-times"></i>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  
  <div class="text-xs text-gray-500 flex items-center gap-2 mt-2" *ngIf="selectedRolesForEntity.length > 0">
    <i class="fas fa-info-circle text-indigo-500"></i>
    <span>Configure Create, Read and Update permissions for each role. Deletes are handled by the system — end-user roles can't delete. Changes must be saved before they take effect.</span>
  </div>
</div>

<!-- Add Role Modal -->
<div 
  class="fixed inset-0 bg-indigo-900/30 backdrop-blur-[3px] z-50 flex items-center justify-center transition-all duration-300"
  *ngIf="showAddRoleModal"
  (click)="toggleAddRoleModal()">
  <div class="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 overflow-hidden" (click)="$event.stopPropagation()">
    <div class="px-6 py-4 border-b border-gray-200 flex justify-between items-center bg-gradient-to-r from-indigo-50 to-indigo-100">
      <h3 class="text-lg font-semibold text-indigo-900 flex items-center gap-2">
        <i class="fas fa-user-plus"></i> Add Role to Entity
      </h3>
      <button 
        class="text-gray-500 hover:text-gray-700 bg-white p-2 rounded-full hover:bg-gray-100 transition-colors duration-150" 
        (click)="toggleAddRoleModal()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    
    <div class="p-6">
      <div *ngIf="getAvailableRoles().length === 0" class="text-center py-8">
        <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
          <i class="fas fa-check-circle text-2xl text-green-600"></i>
        </div>
        <p class="text-gray-600">All available roles have been added to this entity.</p>
      </div>

      <div *ngIf="getAvailableRoles().length > 0" class="max-h-96 overflow-y-auto">
        <p class="text-sm text-gray-600 mb-4">Select a role to add to this entity:</p>
        <div class="space-y-2">
          <button
            *ngFor="let role of getAvailableRoles(); trackBy: trackByRoleId"
            (click)="addRoleToEntity(role)"
            class="w-full text-left px-4 py-3 border border-gray-200 rounded-lg hover:border-indigo-400 hover:bg-indigo-50 transition-all duration-150 flex items-center justify-between group"
          >
            <div class="flex items-center gap-3">
              <div class="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center group-hover:bg-indigo-200 transition-colors">
                <i class="fas fa-user-tag text-indigo-600"></i>
              </div>
              <div>
                <div class="font-semibold text-gray-900 group-hover:text-indigo-900">{{ role.name }}</div>
                <div class="text-xs text-gray-500 font-mono">{{ role.id.split('_').slice(1).join('_') }}</div>
              </div>
            </div>
            <i class="fas fa-arrow-right text-gray-400 group-hover:text-indigo-600 transition-colors"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end">
      <button 
        class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        (click)="toggleAddRoleModal()">
        Close
      </button>
    </div>
  </div>
</div>

<div
  class="shadow-lg m-[10px] my-[20px] p-[20px] rounded-xl border-4 bg-gradient-to-br from-white to-indigo-50 max-w-6xl mx-auto"
  [ngClass]="getColorClass(index)"
>
  <div class="flex justify-between items-center mb-6">
    <div class="text-indigo-900 font-medium flex items-center" *ngIf="hasValidId()">
      <div class="flex flex-col">
        <span class="text-xs uppercase tracking-wider text-indigo-400">Data Model</span>
        <span class="text-xl font-bold">{{ entityData.name }}</span>
      </div>
      <div class="ml-6 flex flex-col">
        <span class="text-xs uppercase tracking-wider text-indigo-400">Path</span>
        <span class="text-sm text-indigo-700">{{ modelName }}</span>
      </div>
    </div>
    <div class="flex items-center" *ngIf="!hasValidId()">
      <span class="text-gray-500 mr-2">Data Model Name:</span>
      <input
        class="rounded-lg border border-solid border-blue-200 h-[36px] bg-white focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent py-1 px-3 w-full text-[16px] transition-all duration-200"
        placeholder="Enter Table Name"
        [(ngModel)]="entityData.name"
        (keyup)="tableNameChanged()"
        pattern="\S+"
        title="Spaces are not allowed"
        autocomplete="off"
      />
      <span class="text-xs text-red-600 mt-1">No word "system" allowed in entity name</span>
    </div>
    <div
      *ngIf="status !== 'OOTB' && !isAdvancedAobContainer"
      class="relative group"
    >
      <button
        class="bg-indigo-600 hover:bg-indigo-700 rounded-md text-white py-[8px] px-[16px] cursor-pointer shadow-sm transition-all duration-300 flex items-center gap-2"
        (click)="addVariableChangeFlag()"
      >
        <i class="fas fa-plus text-sm"></i> Add Variable
      </button>
    </div>
  </div>

  <!-- Table description (feeds AI schema as COMMENT ON TABLE) -->
  <div class="mb-4">
    <div class="text-xs text-indigo-400 uppercase tracking-wider mb-1 flex items-center gap-1">
      <i class="fas fa-info-circle text-amber-500 text-xs"></i> Table Description
      <span class="normal-case text-gray-400 font-normal">(optional — helps AI understand this table)</span>
    </div>
    <input
      class="w-full border border-indigo-200 rounded-lg h-[40px] focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent px-4 text-sm bg-white shadow-sm"
      placeholder="e.g. Stores all incoming leads from Meta ad campaigns"
      [(ngModel)]="entityData.description"
      autocomplete="off"
    />
  </div>

  <div class="overflow-hidden rounded-lg bg-white shadow-md mb-6 border border-indigo-200">
    <div class="grid grid-cols-[600px_200px_200px] bg-gradient-to-r from-indigo-100 to-indigo-50 p-3 border-b border-indigo-100">
      <div class="font-medium text-[16px] text-indigo-900 flex items-center gap-2">
        <i class="fas fa-tag text-indigo-400"></i> Variable Name
      </div>
      <div class="font-medium text-[16px] text-indigo-900 flex items-center gap-2">
        <i class="fas fa-code text-indigo-400"></i> Type
      </div>
      <div class="font-medium text-[16px] text-indigo-900 flex items-center gap-2">
        <i class="fas fa-cog text-indigo-400"></i> Properties
      </div>
    </div>

    <div
      class="grid grid-cols-[600px_200px_200px_30px] hover:bg-indigo-50 transition-colors duration-150 border-b border-gray-100 relative group"
      *ngFor="let model of entityData.data; let i = index"
    >
      <div class="py-3 pl-3 cursor-pointer font-medium text-gray-700">
        {{ model.name }}
      </div>
      <div class="py-3 text-gray-700">
        <span class="px-2 py-1 rounded-md bg-indigo-50 text-indigo-700 text-sm">{{ model.type }}</span>
      </div>
      <div
        class="py-3"
        *ngIf="
          model.isUnique &&
          model.type !== 'AUTO_INCREMENT' &&
          model.type !== 'ARRAY_OF_STRING' &&
          model.type !== 'ARRAY_OF_NUMBER' &&
          model.type !== 'ARRAY_OF_OBJECT' &&
          model.type !== 'BOOLEAN' &&
          model.type !== 'TIMESTAMP' &&
          model.type !== 'GEOMETRY' &&
          model.type !== 'UUID' &&
          model.type !== 'ENTITY_REFERENCE'
        "
      >
        <span class="text-amber-600 bg-amber-50 px-2 py-1 rounded-full text-xs border border-amber-100">
          <i class="fas fa-fingerprint mr-1"></i> Unique
        </span>
      </div>
      <div
        class="py-3"
        *ngIf="
          !model.isUnique &&
          model.type !== 'AUTO_INCREMENT' &&
          model.type !== 'ARRAY_OF_STRING' &&
          model.type !== 'ARRAY_OF_NUMBER' &&
          model.type !== 'ARRAY_OF_OBJECT' &&
          model.type !== 'BOOLEAN' &&
          model.type !== 'TIMESTAMP' &&
          model.type !== 'GEOMETRY' &&
          model.type !== 'UUID' &&
          model.type !== 'ENTITY_REFERENCE'
        "
      ></div>
      <div
        class="py-3"
        *ngIf="model.type == 'UUID' && !model.primaryKey"
      ></div>
      <div
        class="py-3"
        *ngIf="model.type == 'UUID' && model.primaryKey"
      >
        <span class="text-indigo-600 bg-indigo-50 px-2 py-1 rounded-full text-xs border border-indigo-100">
          <i class="fas fa-key mr-1"></i> Primary Key
        </span>
      </div>
      <div
        class="py-3"
        *ngIf="
          model.type == 'ARRAY_OF_STRING' ||
          model.type == 'ARRAY_OF_NUMBER' ||
          model.type == 'ARRAY_OF_OBJECT' ||
          model.type == 'BOOLEAN' ||
          model.type == 'TIMESTAMP' ||
          model.type == 'GEOMETRY'
        "
      ></div>
      <div
        class="py-3"
        *ngIf="model.type == 'ENTITY_REFERENCE'"
      >
        <div class="bg-blue-50 rounded-md p-2 text-xs border border-blue-100">
          <div class="text-blue-700"><i class="fas fa-link mr-1"></i> Entity: <span class="text-gray-700">{{ model.referenceEntityName }}</span></div>
          <div class="text-blue-700"><i class="fas fa-table mr-1"></i> Column: <span class="text-gray-700">{{ model.referenceEntityColumnName }}</span></div>
        </div>
      </div>
      <!-- <div
        class="py-3"
        *ngIf="model.type == 'SHARED_ENTITY_REFERENCE'"
      >
        <div class="bg-amber-50 rounded-md p-2 text-xs border border-amber-200">
          <div class="flex items-center gap-2 text-amber-700">
            <i class="fas fa-share-alt"></i>
            <span class="font-medium">{{ getEntityNameById(model.referenceEntityName) }}</span>
            <span class="text-amber-400">→</span>
            <span class="font-mono text-gray-700">{{ model.referenceEntityColumnName }}</span>
          </div>
        </div>
      </div> -->
      <div
        class="py-3"
        *ngIf="model.type == 'AUTO_INCREMENT'"
      >
        <div class="text-blue-700 text-sm">Starts From: <span class="text-gray-700">{{ model.startIncrementFrom }}</span></div>
      </div>
      <div
        *ngIf="
          editFlag &&
          model.name !== 'id' &&
          model.name !== 'id_auto_increment' &&
          model.name !== 'parent_id' &&
          checkDeleteFalgForObject(i)
        "
        class="w-[20px] h-full flex flex-col justify-center cursor-pointer group-hover:opacity-100 opacity-50 transition-opacity duration-200"
      >
        <div class="p-1 hover:bg-red-100 rounded-full transition-colors duration-150" (click)="deleteVariable(i)">
          <img src="assets/icons/delete-icon.svg" alt="Delete" class="hover:scale-110 transition-transform duration-150" />
        </div>
      </div>
      <div
        *ngIf="
          model.name !== 'id' &&
          model.name !== 'id_auto_increment' &&
          model.name !== 'parent_id' &&
          model.type !== 'ARRAY_OF_OBJECT'
        "
        class="w-[20px] h-full flex flex-col justify-center cursor-pointer group-hover:opacity-100 opacity-50 transition-opacity duration-200"
      >
        <div class="p-1 hover:bg-blue-100 rounded-full transition-colors duration-150" (click)="editVariable(i)">
          <img src="assets/icons/edit_icon.svg" alt="Edit" class="hover:scale-110 transition-transform duration-150" />
        </div>
      </div>
    </div>
  </div>
  <!-- Predefined rows — MOVED TO entity-list.component (this app-entity editor is unused). Kept commented for reference:
  <div
    *ngIf="index == 0 && (status == 'NEW' || status == 'LOCAL') && predefinedFields.length"
    class="overflow-hidden rounded-lg bg-white shadow-md mb-6 border border-indigo-200"
  >
    <div class="bg-gradient-to-r from-indigo-100 to-indigo-50 p-4 border-b border-indigo-100 flex items-center justify-between">
      <div class="text-indigo-900 font-semibold flex items-center gap-2">
        <i class="fas fa-table"></i> Predefined rows
        <span class="text-xs text-indigo-500 font-normal">— seed data; local lists auto-fill with these at runtime (no push needed)</span>
      </div>
      <button
        class="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded-md text-sm flex items-center gap-2"
        (click)="addPredefinedRow()"
      >
        <i class="fas fa-plus text-xs"></i> Add row
      </button>
    </div>
    <div class="overflow-x-auto" *ngIf="predefinedRows.length; else noPredefinedRows">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-gray-600">
            <th *ngFor="let f of predefinedFields" class="text-left px-3 py-2 font-medium whitespace-nowrap">
              {{ f.name }} <span class="text-[10px] text-gray-400">{{ f.type }}</span>
            </th>
            <th class="px-3 py-2 w-10"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of predefinedRows; let r = index" class="border-t border-gray-100 hover:bg-indigo-50/40">
            <td *ngFor="let f of predefinedFields" class="px-3 py-1.5">
              <input *ngIf="f.type == 'STRING'" type="text" class="w-full border border-gray-200 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-indigo-400" [(ngModel)]="row[f.name]" />
              <input *ngIf="f.type == 'NUMBER'" type="number" class="w-full border border-gray-200 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-indigo-400" [(ngModel)]="row[f.name]" />
              <input *ngIf="f.type == 'TIMESTAMP'" type="datetime-local" class="w-full border border-gray-200 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-indigo-400" [(ngModel)]="row[f.name]" />
              <input *ngIf="f.type == 'BOOLEAN'" type="checkbox" class="h-4 w-4 accent-indigo-600" [(ngModel)]="row[f.name]" />
            </td>
            <td class="px-3 py-1.5 text-center">
              <button class="text-red-400 hover:text-red-600" (click)="removePredefinedRow(r)" title="Remove row">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #noPredefinedRows>
      <div class="p-4 text-sm text-gray-400">No predefined rows yet — click “Add row” to seed this list.</div>
    </ng-template>
  </div>
  -->

  <div class="" *ngFor="let data of entityData.data; let i = index">
    <span *ngIf="data.type == 'ARRAY_OF_OBJECT'" class="block border-l-4 border-indigo-300 pl-4 mt-4">
      <app-entity
        [modelNameInput]="modelName"
        [(entityData)]="entityData.data[i]"
        [index]="index + 1"
        [editFlag]="editFlag"
      ></app-entity>
    </span>
  </div>
  <div class="flex justify-around mt-[60px]" *ngIf="index == 0">
    <div class="flex gap-4 flex-wrap justify-center">
      <div
        *ngIf="status == 'NEW'"
        class="relative overflow-hidden group"
      >
        <button
          class="bg-indigo-600 hover:bg-indigo-700 rounded-md text-white py-[10px] px-[24px] cursor-pointer shadow-sm transition-all duration-300 flex items-center gap-2"
          (click)="FinalizeTableChanges()"
        >
          <i class="fas fa-check-circle"></i> Finalize
        </button>
      </div>
      
      <div
        *ngIf="status == 'NEW'"
        class="relative overflow-hidden group"
      >
        <button
          class="bg-gray-600 hover:bg-gray-700 rounded-md text-white py-[10px] px-[24px] cursor-pointer shadow-sm transition-all duration-300 flex items-center gap-2"
          (click)="LocalTableChanges()"
        >
          <i class="fas fa-save"></i> LOCAL
        </button>
      </div>
      
      <div class="relative overflow-hidden group">
        <button
          class="bg-blue-600 hover:bg-blue-700 rounded-md text-white py-[10px] px-[24px] cursor-pointer shadow-sm transition-all duration-300 flex items-center gap-2"
          (click)="SaveTableChanges()"
        >
          <i class="fas fa-save"></i> Save
        </button>
      </div>
      
      <div
        *ngIf="status == 'READY' || status == 'PENDING' || status == 'SYNCED' || status == 'ERROR'"
        class="relative overflow-hidden group"
      >
        <button
          class="bg-teal-600 hover:bg-teal-700 rounded-md text-white py-[10px] px-[24px] cursor-pointer shadow-sm transition-all duration-300 flex items-center gap-2"
          (click)="UpdateTableChanges()"
        >
          <i class="fas fa-sync-alt"></i> Update
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="h-[100vh] w-[100vw] fixed z-[90] top-0 left-0 bg-indigo-900/30 backdrop-blur-[3px] transition-all duration-300"
  *ngIf="addVariableFlag"
>
  <div class="flex flex-col justify-center h-full">
    <div class="flex justify-center">
      <div
        class="relative w-[702px] bg-white rounded-xl px-[64px] py-[40px] shadow-2xl animate-modalSlide"
      >
        <div
          class="absolute top-[20px] right-[20px] cursor-pointer bg-indigo-100 p-2 rounded-full hover:bg-indigo-200 transition-all duration-300 transform hover:rotate-90"
          (click)="addVariableChangeFlag()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round" 
            stroke-linejoin="round"
            class="text-indigo-700"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        
        <div class="flex flex-col gap-[30px]">
          <div class="relative">
            <div class="text-[28px] font-medium text-center leading-[32px] text-indigo-900 mb-8">
              {{ editingVariableIndex !== null ? 'Edit Variable' : 'Add Variable' }}
            </div>
            <div class="absolute left-0 right-0 bottom-0 h-[3px] bg-gradient-to-r from-indigo-300 to-amber-300"></div>
          </div>
          
          <div class="flex gap-[40px] flex-wrap">
            <div class="min-w-[250px]">
              <div class="text-[16px] text-indigo-700 pb-[6px] flex items-center gap-2">
                <i class="fas fa-signature text-amber-500"></i> Variable Name
              </div>
              <div
                class="w-full h-[48px] border border-solid border-indigo-200 rounded-lg overflow-hidden transition-all duration-200 focus-within:ring-2 focus-within:ring-indigo-400 focus-within:border-transparent shadow-sm"
              >
                <input
                  class="w-full h-full text-[15px] focus:outline-none px-4 py-2"
                  placeholder="Enter variable name"
                  [(ngModel)]="newVariableData.name"
                  (keyup)="variableNameChanged()"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
              </div>
            </div>
            
            <div class="min-w-[250px]">
              <div class="text-[16px] text-indigo-700 pb-[6px] flex items-center gap-2">
                <i class="fas fa-code text-amber-500"></i> Variable Type
              </div>
              <div class="w-full h-[48px] rounded-lg overflow-hidden">
                <div
                  class="w-full h-[48px] border border-solid border-indigo-200 rounded-lg overflow-hidden transition-all duration-200 focus-within:ring-2 focus-within:ring-indigo-400 focus-within:border-transparent shadow-sm"
                >
                  <select
                    class="focus:outline-none h-full w-full bg-transparent px-4 py-2 text-[15px] appearance-none cursor-pointer"
                    [(ngModel)]="newVariableData.type"
                    (change)="newVariableTypeChanged()"
                    [disabled]="editingVariableIndex !== null && !editFlag"
                  >
                    <option class="hidden" value="">Select type</option>
                    <option class="p-[8px]" *ngFor="let type of dataTypes">
                      {{ type }}
                    </option>
                  </select>
                  <div class="absolute right-[24px] top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <i class="fas fa-chevron-down text-indigo-400"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Advanced is allowed ONLY on a top-level AOB (index === 0). A nested AOB cannot be advanced. -->
            <div class="min-w-[250px] flex items-end" *ngIf="newVariableData.type == 'ARRAY_OF_OBJECT' && index === 0">
              <label class="inline-flex items-center gap-3 cursor-pointer select-none">
                <input
                  type="checkbox"
                  class="w-5 h-5 rounded border-2 border-gray-300 text-indigo-600 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 cursor-pointer transition-all duration-150"
                  [(ngModel)]="newVariableData.extendedAttributes"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
                <span class="text-[15px] text-indigo-700">Advanced</span>
              </label>
            </div>
          </div>

          <!-- Unique key — REMOVED 2026-09-17 (owner), same as entity-list.component. See .scratch/entity-field-types/.
          Was:
          <div class="flex gap-[20px] items-center" *ngIf="newVariableUniqueFlag">
            <div class="text-[16px] text-blue-700 pb-[4px]">Unique Key:</div>
            <div class="flex items-center gap-[20px]">
              <span class="flex items-center">
                <input
                  type="radio"
                  id="unique-yes"
                  name="uniqueKey"
                  [(ngModel)]="newVariableData.isUnique"
                  [value]="true"
                  class="mr-[8px] h-4 w-4 accent-blue-600"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
                <label for="unique-yes" class="text-[14px] text-gray-700"
                  >Yes</label
                >
              </span>
              <span class="flex items-center">
                <input
                  type="radio"
                  id="unique-no"
                  name="uniqueKey"
                  [(ngModel)]="newVariableData.isUnique"
                  [value]="false"
                  class="mr-[8px] h-4 w-4 accent-blue-600"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
                <label for="unique-no" class="text-[14px] text-gray-700"
                  >No</label
                >
              </span>
            </div>
          </div>
          -->
          <div
            class="flex gap-[20px] items-center"
            *ngIf="newVariableData.type == 'AUTO_INCREMENT'"
          >
            <div>
              <div class="text-[16px] text-blue-700 pb-[4px]">
                Increment Starts From
              </div>
              <div class="text-red-500 text-[12px]">* cannot be negative</div>
            </div>
            <div
              class="w-[100px] h-[40px] border border-solid border-blue-200 rounded-[8px] pl-[12px] overflow-hidden transition-all duration-200 focus-within:ring-2 focus-within:ring-blue-400 focus-within:border-transparent"
            >
              <input
                class="w-full h-full text-[14px] focus:outline-none"
                placeholder="Enter"
                type="number"
                min="0"
                [(ngModel)]="newVariableData.startIncrementFrom"
                (change)="newVaraibleStartIncementChange()"
                [disabled]="editingVariableIndex !== null && !editFlag"
                autocomplete="off"
              />
            </div>
          </div>
          <div
            class="flex gap-[32px]"
            *ngIf="newVariableData.type == 'ENTITY_REFERENCE'"
          >
            <div class="flex justify-center">
              {{ entityService.completeFinalizedEntityList.length }} /
              {{ entityService.completeFinalizedEntityList.length }}
              {{ entityService.completeFinalizedEntityList[0].name }}/{{ modelName }}
              <!-- Was (2026-10-16, self-reference): this div's *ngIf was
                !entityService.completeFinalizedEntityList.length ||
                !(
                (entityService.completeFinalizedEntityList.length == 1 &&
                entityService.completeFinalizedEntityList[0].name !==
                modelName) ||
                entityService.completeFinalizedEntityList.length > 1
                )
              -->
              <div
                class="text-[16px] text-red-500 pb-[4px]"
                *ngIf="referenceTargetChoices.length === 0"
              >
                No other data entities available
              </div>
              <!-- Was (2026-10-16, self-reference): this div's *ngIf was
                (entityService.completeFinalizedEntityList.length == 1 &&
                entityService.completeFinalizedEntityList[0].name !==
                modelName) ||
                entityService.completeFinalizedEntityList.length > 1
              -->
              <div
                class="text-[16px] text-blue-700 pb-[4px]"
                *ngIf="referenceTargetChoices.length > 0"
              >
                Select Entity:
              </div>
              <!-- Was (2026-10-16, self-reference): this div's *ngIf was
                (entityService.completeFinalizedEntityList.length == 1 &&
                entityService.completeFinalizedEntityList[0].name !==
                modelName) ||
                entityService.completeFinalizedEntityList.length > 1
              -->
              <div
                class="w-[271px] h-[40px] rounded-[8px] overflow-hidden"
                *ngIf="referenceTargetChoices.length > 0"
              >
                <div
                  class="w-[200px] h-[40px] border border-solid border-blue-200 rounded-[8px] overflow-hidden text-[14px] px-[12px] transition-all duration-200 focus-within:ring-2 focus-within:ring-blue-400 focus-within:border-transparent"
                >
                  <select
                    class="focus:outline-none h-full w-full bg-transparent"
                    [(ngModel)]="newVariableData.referenceEntityName"
                    (change)="newVariableReferenceEntityChanged()"
                    [disabled]="editingVariableIndex !== null && !editFlag"
                  >
                    <option class="hidden" value="">Select</option>
                    <!-- Was (2026-10-16, self-reference):
                    <ng-container *ngFor="let entityListFinalized of entityService.completeFinalizedEntityList">
                      <option *ngIf="entityListFinalized.name !== modelName" class="p-[4px]" [value]="entityListFinalized.id">{{ entityListFinalized.name }}</option>
                    </ng-container>
                    -->
                    <option *ngFor="let t of referenceTargetChoices" class="p-[4px]" [value]="t.id">{{ t.label }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- SHARED_ENTITY_REFERENCE Section -->
          <!-- <div
            class="flex flex-col gap-[16px]"
            *ngIf="newVariableData.type == 'SHARED_ENTITY_REFERENCE'"
          >
            <div class="bg-amber-50 border border-amber-200 rounded-lg p-4">
              <div class="flex items-start gap-3">
                <i class="fas fa-info-circle text-amber-600 text-lg mt-0.5"></i>
                <div class="flex-1">
                  <div class="font-semibold text-amber-900 mb-2">Shared Entity Reference (SER)</div>
                  <ul class="text-sm text-amber-800 space-y-1.5 ml-4">
                    <li class="flex items-start"><span class="mr-2">•</span><span>Creates UUID column on this entity</span></li>
                    <li class="flex items-start"><span class="mr-2">•</span><span>Creates reverse reference column on target entity</span></li>
                    <li class="flex items-start"><span class="mr-2">•</span><span>You must manage associations manually in your code</span></li>
                    <li class="flex items-start"><span class="mr-2">•</span><span>Not auto-fetched in queries (requires explicit filtering)</span></li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <div
                class="text-[16px] text-red-500 pb-[4px]"
                *ngIf="
                  !entityService.completeFinalizedEntityList.length ||
                  !(
                    (entityService.completeFinalizedEntityList.length == 1 &&
                      entityService.completeFinalizedEntityList[0].name !==
                        modelName) ||
                    entityService.completeFinalizedEntityList.length > 1
                  )
                "
              >
                No other data entities available
              </div>
              <div
                class="text-[16px] text-amber-700 pb-[4px] font-medium"
                *ngIf="
                  (entityService.completeFinalizedEntityList.length == 1 &&
                    entityService.completeFinalizedEntityList[0].name !==
                      modelName) ||
                  entityService.completeFinalizedEntityList.length > 1
                "
              >
                Target Entity:
              </div>
              <div
                class="w-[271px] h-[40px] rounded-[8px] overflow-hidden"
                *ngIf="
                  (entityService.completeFinalizedEntityList.length == 1 &&
                    entityService.completeFinalizedEntityList[0].name !==
                      modelName) ||
                  entityService.completeFinalizedEntityList.length > 1
                "
              >
                <div
                  class="w-full h-[40px] border border-solid border-amber-200 rounded-[8px] overflow-hidden text-[14px] px-[12px] transition-all duration-200 focus-within:ring-2 focus-within:ring-amber-400 focus-within:border-transparent"
                >
                  <select
                    class="focus:outline-none h-full w-full bg-transparent"
                    [(ngModel)]="newVariableData.referenceEntityName"
                    (change)="serTargetEntityChanged()"
                    [disabled]="editingVariableIndex !== null && !editFlag"
                  >
                    <option value="" disabled>Select target entity</option>
                    <ng-container
                      *ngFor="
                        let entityListFinalized of entityService.completeFinalizedEntityList
                      "
                    >
                      <option 
                        *ngIf="entityListFinalized.name !== modelName" 
                        class="p-[4px]" 
                        [value]="entityListFinalized.id"
                      >
                        {{ entityListFinalized.name }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>

            <div *ngIf="newVariableData.referenceEntityName">
              <div class="text-[16px] text-amber-700 pb-[4px] font-medium">
                Column Name on Target Entity (will be created):
              </div>
              <div class="w-[271px] h-[40px] border border-solid border-amber-200 rounded-[8px] overflow-hidden text-[14px] px-[12px] transition-all duration-200 focus-within:ring-2 focus-within:ring-amber-400 focus-within:border-transparent">
                <input
                  class="focus:outline-none h-full w-full bg-transparent"
                  type="text"
                  [(ngModel)]="newVariableData.referenceEntityColumnName"
                  (input)="serReverseColumnNameChanged()"
                  placeholder="e.g., parent_ids, invoice_ids"
                  [disabled]="editingVariableIndex !== null && !editFlag"
                  autocomplete="off"
                />
              </div>
              <div class="text-xs text-amber-600 mt-2 ml-1">
                <i class="fas fa-arrow-right mr-1"></i>
                Will create UUID column "{{ newVariableData.referenceEntityColumnName || '(name)' }}" on <strong>{{ getTargetEntityName() }}</strong>
              </div>
            </div>
          </div> -->

          <div class="flex gap-[20px] mb-[30px] items-center" *ngIf="newVariableData.type == 'STRING' || newVariableData.type == 'NUMBER' || newVariableData.type == 'BOOLEAN'">
            <div class="text-[16px] text-blue-700 pb-[4px]">
                Default Value:
            </div>
            <div
              class="flex gap-[30px] h-[40px] rounded-[8px] overflow-hidden"
            >
              <div
                *ngIf="newVariableData.type == 'BOOLEAN'"
                class="w-[170px] h-[40px] border border-solid border-blue-200 rounded-[8px] overflow-hidden text-[14px] px-[12px] transition-all duration-200 focus-within:ring-2 focus-within:ring-blue-400 focus-within:border-transparent"
              >
                <select
                    class="focus:outline-none h-full w-full bg-transparent"
                    [(ngModel)]="newVariableData.defaultValue"
                  >
                    <option class="p-[4px]" *ngFor="let opt of booleanOptions" [ngValue]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>

              </div>
              <app-default-value-editor
                [type]="newVariableData.type"
                [value]="newVariableData.defaultValue"
                (valueChange)="newVariableData.defaultValue = $event"
                inputClass="focus:outline-none h-[40px] w-[170px] bg-transparent border border-solid border-blue-200 rounded-[8px] text-[14px] px-[12px] disabled:opacity-40"
              ></app-default-value-editor>
            </div>
          </div>
          <div class="flex flex-col gap-[6px] mb-[10px]">
            <div class="text-[16px] text-indigo-700 pb-[4px] flex items-center gap-2">
              <i class="fas fa-info-circle text-amber-500"></i> Description
              <span class="text-xs text-gray-400 font-normal">(optional — helps AI understand this field)</span>
            </div>
            <div class="w-full border border-solid border-indigo-200 rounded-lg overflow-hidden transition-all duration-200 focus-within:ring-2 focus-within:ring-indigo-400 focus-within:border-transparent shadow-sm">
              <input
                class="w-full h-[48px] text-[15px] focus:outline-none px-4 py-2"
                placeholder="e.g. Timestamp when the lead submitted the form"
                [(ngModel)]="newVariableData.description"
                autocomplete="off"
              />
            </div>
          </div>

          <div class="flex justify-around mt-6">
            <button
              class="bg-indigo-600 hover:bg-indigo-700 px-8 py-3 rounded-md text-white text-[16px] shadow-sm transition-all duration-300 flex items-center gap-2"
              (click)="editingVariableIndex !== null ? updateVariable() : addVariable()"
              *ngIf="addVariableButtonFlag"
            >
              <i class="fas fa-{{ editingVariableIndex !== null ? 'sync-alt' : 'plus-circle' }}"></i>
              {{ editingVariableIndex !== null ? 'Update Variable' : 'Add Variable' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="h-[100vh] w-[100vw] fixed z-[90] top-0 left-0 bg-red-900/30 backdrop-blur-[3px] transition-all duration-300"
  *ngIf="showExitWarning"
>
  <div class="flex flex-col justify-center h-full">
    <div class="flex justify-center">
      <div
        class="relative w-[400px] bg-white rounded-xl px-[32px] py-[28px] shadow-2xl animate-warningPulse"
      >
        <div class="text-[22px] font-bold text-center leading-[24px] text-red-600 mb-2 flex justify-center items-center gap-3">
          <div class="bg-red-100 p-3 rounded-full">
            <i class="fas fa-exclamation-triangle text-xl"></i>
          </div>
          <span>Unsaved Changes</span>
        </div>
        <div class="text-[15px] text-center mt-[16px] text-gray-700">
          You have unsaved changes that will be lost if you leave. Do you want to proceed?
        </div>
        <div class="flex justify-center gap-6 mt-[32px]">
          <button
            class="bg-white border border-red-500 text-red-600 py-[8px] px-[20px] rounded-md hover:bg-red-50 transition-all duration-200 flex items-center gap-2"
            (click)="confirmExit()"
          >
            <i class="fas fa-sign-out-alt"></i> Leave
          </button>
          <button
            class="bg-indigo-600 hover:bg-indigo-700 text-white py-[8px] px-[20px] rounded-md shadow-sm transition-all duration-300 flex items-center gap-2"
            (click)="cancelExit($event)"
          >
            <i class="fas fa-save"></i> Stay
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes modalSlide {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes warningPulse {
    0% { transform: scale(0.95); opacity: 0; }
    70% { transform: scale(1.02); }
    100% { transform: scale(1); opacity: 1; }
  }
  
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-out forwards;
  }
  
  .animate-modalSlide {
    animation: modalSlide 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  }
  
  .animate-warningPulse {
    animation: warningPulse 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #a5b4fc;
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #818cf8;
  }
  
  select {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%234f46e5' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
  }
</style>